import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { PersistenceService } from '@barthauer/abc/core/data';
import { AbcButtonComponent, AbcDatepickerComponent, AbcInputComponent } from '@barthauer/abc/ui-components';
import { DocumentModel } from '../../../models/document.model';
import { DocumentsEditorsService } from '../../../services/documents-editors.service';
import { ValueWrapper, ValueWrapperViewModel } from '../../../services/valueWrapper';

@Component({
  selector: 'documents-editor-details',
  templateUrl: './documents-editor-table-details.component.html',
  styleUrls: ['./documents-editor-table-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentsEditorTableDetailsComponent implements OnInit {
  document: DocumentModel;
  objectType: string;
  private _parentInfo: any;
  objectKey;
  private listOfValueWrappers = {};
  private componentContainer = [];
  @Input()
  get parentInfo(): any {
    return this._parentInfo;
  }
  set parentInfo(parentInfo: any) {
    this.document = parentInfo.documentData;
    this.objectKey.id = parentInfo.documentData.Id;
    this.objectType = parentInfo.objectType.toString();
    this.fillFields(parentInfo.documentData);
  }
  @ViewChild('okButton', { static: true }) okButton: AbcButtonComponent;
  @ViewChild('cancelButton', { static: true }) cancelButton: AbcButtonComponent;
  @ViewChild('resetButton', { static: true }) resetButton: AbcButtonComponent;
  @ViewChild('designationInput', { static: true }) designationInput: AbcInputComponent;
  @ViewChild('dateInput', { static: true }) dateInput: AbcDatepickerComponent;
  @ViewChild('fileNameInput', { static: true }) fileNameInput: AbcInputComponent;
  @ViewChild('documentKindInput', { static: true }) documentKindInput: AbcInputComponent;
  @ViewChild('dataCarrierInput', { static: true }) dataCarrierInput: AbcInputComponent;
  @ViewChild('numberInput', { static: true }) numberInput: AbcInputComponent;
  @ViewChild('programPathInput', { static: true }) programPathInput: AbcInputComponent;
  @ViewChild('validFromInput', { static: true }) validFromInput: AbcDatepickerComponent;
  @ViewChild('validUntilInput', { static: true }) validUntilInput: AbcDatepickerComponent;
  @ViewChild('Comment', { static: true }) Comment;

  constructor(
    private persistenceService: PersistenceService,
    private documentsEditorsService: DocumentsEditorsService
  ) {
    this.objectKey = new ValueWrapperViewModel(this.persistenceService);
  }

  ngOnInit() {
    this.componentContainer.push(
      this.designationInput,
      this.dateInput,
      this.fileNameInput,
      this.documentKindInput,
      this.dataCarrierInput,
      this.numberInput,
      this.programPathInput,
      this.validFromInput,
      this.validUntilInput
    );

    this.objectKey.objectType = 'Document';

    this.designationInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.designationInput.htmlAttributes.id].value = result.newValue;
    });
    this.dateInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.dateInput.htmlAttributes.id].value = result.newValue;
    });
    this.fileNameInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.fileNameInput.htmlAttributes.id].value = result.newValue;
    });
    this.documentKindInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.documentKindInput.htmlAttributes.id].value = result.newValue;
    });
    this.dataCarrierInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.dataCarrierInput.htmlAttributes.id].value = result.newValue;
    });
    this.numberInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.numberInput.htmlAttributes.id].value = result.newValue;
    });
    this.programPathInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.programPathInput.htmlAttributes.id].value = result.newValue;
    });
    this.validFromInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.validFromInput.htmlAttributes.id].value = result.newValue;
    });
    this.validUntilInput.onChange.subscribe((result) => {
      this.listOfValueWrappers[this.validUntilInput.htmlAttributes.id].value = result.newValue;
    });
    this.okButton.addEventListener('click', () => {
      this.persistenceService.persistPendingChanges();
      this.documentsEditorsService.callUpdateDataSubject();
      this.documentsEditorsService.callCloseDialogSubject();
    });

    this.cancelButton.addEventListener('click', () => {
      this.documentsEditorsService.callCloseDialogSubject();
    });
    this.resetButton.addEventListener('click', () => {
      this.persistenceService.revertPendingChanges();
    });
  }
  fillFields(data) {
    this.designationInput.value = data.Designation;
    this.dateInput.value = data.Date;
    this.fileNameInput.value = data.FileName;
    this.documentKindInput.value = data.Kind;
    this.dataCarrierInput.value = data.DataCarrier;
    this.numberInput.value = data.value;
    this.programPathInput.value = data.value;
    this.validFromInput.value = data.ValidFrom;
    this.validUntilInput.value = data.ValidUntil;
    this.Comment.value = data.Comment;
    for (const property in data) {
      this.listOfValueWrappers[property] = new ValueWrapper(
        property,
        data[property],
        this.objectKey,
        this.persistenceService
      );
    }
    this.objectKey.listOfValueWrappers = this.listOfValueWrappers;
    this.objectKey.abcComponentContainer = this.componentContainer;
  }
}
